const digest = '114a34151f46f94a7a6d67549d926d582cbc7fec8882a6d074be593e4c758caf';
const css = `._dateInput_br824_1{background-color:#fbfbfb;border:.0625rem solid #bdbdbd;border-radius:.5rem;color:#737373;display:block;font-size:1rem;line-height:1.375rem;min-height:1rem!important;padding:0 .625rem;transition:border-color .25s ease-out;width:100%}._dateInput_br824_1:focus:not(:disabled){border-color:#006fcf;outline:none}._dateInput_br824_1::placeholder{color:#8c8c8c}._inputField_br824_22,._inputField_br824_22>:first-child{flex-grow:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'dateInput': '_dateInput_br824_1', 'inputField': '_inputField_br824_22' };
export const dateInput = '_dateInput_br824_1';
export const inputField = '_inputField_br824_22';
export { css, digest };